import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCloudflareComponent } from './simple-icons-cloudflare.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCloudflareComponent ],
    exports:      [ SimpleIconsCloudflareComponent ],
    bootstrap:    []
})
export class SimpleIconsCloudflareModule {}
